module.exports = __webpack_public_path__ + "img/table-document-icon.140b2b5b.svg";